module.exports = __webpack_public_path__ + "static/media/floatingButtonGrey@3x.2e00b406.png";